import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { AuthenticationService } from "../authentication.service";
import { EnvironmentService } from "../index";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Car } from "app/_models";
import { ServiceOffer } from "app/_models/serviceoffer";

@Injectable()
export class MatrixCarService {
  private baseUrl: string =
    this.environmentService.getBaseURL() + "/api" + "/matrix/cars";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getMatrixCarsByDealer(id: string): Observable<Car[]> {
    let cars$ = this.http
      .get(`${this.baseUrl}/dealer/${id}`, this.makeHeaders())
      .map((response) => response.json())
      .catch((e) => {
        console.log(e);
        return [];
      });
    return cars$;
  }

  getCarPrices(carId: string): Observable<ServiceOffer[]> {
    return this.http
      .get(`${this.baseUrl}/${carId}/prices`, this.makeHeaders())
      .map((response: Response) => response.json());
  }

  getCar(carId: string): Observable<Car> {
    return this.http
      .get(`${this.baseUrl}/${carId}`, this.makeHeaders())
      .map((response: Response) => response.json());
  }

  addCarDetails(car: Partial<Car>): Observable<Car> {
    return this.http
      .post(
        `${this.baseUrl}`,
        JSON.stringify({
          carModel: car.carmodel,
          carMake: car.carmake,
          carVariant: car.carversion,
          dealerId: car.dealer_id,
          externalCarId: car.externalcarid,
          kmPerService: car.kmPerService,
          yearsPerService: car.yearsPerService
        }),
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }

  clone(carToBeCloned: Car, clone: Car): Observable<Car> {
    return this.http
      .post(
        `${this.baseUrl}/${clone._id}/clone`,
        JSON.stringify({
          carModel: carToBeCloned.carmodel,
          carMake: carToBeCloned.carmake,
          carVariant: carToBeCloned.carversion,
          externalCarId: carToBeCloned.externalcarid,
          kmPerService: carToBeCloned.kmPerService,
          yearsPerService: carToBeCloned.yearsPerService,
          dealerId: clone.dealer_id,
        }),
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }

  saveCarDetails(car: Car): Observable<any> {
    return this.http
      .put(
        `${this.baseUrl}/${car._id}`,
        JSON.stringify({
          carModel: car.carmodel,
          carMake: car.carmake,
          carVariant: car.carversion,
          externalCarId: car.externalcarid,
          kmPerService: car.kmPerService,
          yearsPerService: car.yearsPerService
        }),
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }

  saveCarPrice(
    car: Car,
    price: Partial<ServiceOffer>
  ): Observable<ServiceOffer> {
    return this.http
      .put(
        `${this.baseUrl}/${car._id}/prices`,
        JSON.stringify({
          km: price.km,
          priceId: price._id,
          price: price.price,
          age: price.years,
        }),
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }

  deleteCarPrice(price: ServiceOffer) {
    return this.http
      .delete(`${this.baseUrl}/${price._id}/prices`, this.makeHeaders())
      .map((response: Response) => response.json());
  }

  deleteCar(car: Car) {
    return this.http
      .delete(`${this.baseUrl}/${car._id}`, this.makeHeaders())
      .map((response: Response) => response.json());
  }

  saveCarPricingExcel(file: FormData): Observable<Response> {
    return this.http.post(
      `${this.baseUrl}/upload-spreadsheet`,
      file,
      this.makeHeadersForFiles()
    );
  }
  // Headers for post with file
  private makeHeadersForFiles(): RequestOptions {
    let headers = new Headers();
    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/matrix/matrix-cars.service.ts